import { IUserShopsData, IUserShopsAction } from 'models/user/usershops';
import { INodeDto } from 'models/common';
import { IStore } from 'redux/IStore';

/** Action Types */
export const GET_REQUEST: string = 'usershops/GET_REQUEST';
export const GET_SUCCESS: string = 'usershops/GET_SUCCESS';
export const GET_FAILURE: string = 'usershops/GET_FAILURE';

/** Initial State */
const initialState: IUserShopsData = {
	userShops: [],
};

/** Reducer */
export function userShopsReducer(state = initialState, action: IUserShopsAction) {
	switch (action.type) {
		case GET_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				userShops: action.payload.userShops,
			});

		case GET_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function getUserShops() {
	return (dispatch, getState: () => IStore) => {
		dispatch(userShopsRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/GetByUser',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(userShopsSuccess(res)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userShopsFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userShopsFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userShopsFailure(err));
			});
	};
}

/** Action Creator */
export function userShopsRequest(): IUserShopsAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function userShopsSuccess(userShops: INodeDto[]): IUserShopsAction {
	return {
		type: GET_SUCCESS,
		payload: {
			userShops,
		},
	};
}

/** Action Creator */
export function userShopsFailure(message: any): IUserShopsAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}
